import { render, staticRenderFns } from "./AboutYou.vue?vue&type=template&id=390ecf28&"
import script from "./AboutYou.vue?vue&type=script&lang=js&"
export * from "./AboutYou.vue?vue&type=script&lang=js&"
import style0 from "./AboutYou.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports